module.exports = __webpack_public_path__ + "static/media/badge_level_6_2.20eb845f.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_6_2.png
// module id = 505
// module chunks = 0